import styled from 'styled-components'

import { textStyles } from '../../theme'
import ActionButton from '../../components/ActionButton'

export const Content = styled.div`
  padding: 4rem 1rem;
  flex-grow: 1;
  display: flex;
`

export const Box = styled.div`
  max-width: 640px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
`

export const Title = styled.h1`
  ${textStyles.titleH1};
  white-space: pre-wrap;
`

export const Divider = styled.div`
  margin-top: 25px;
  height: 1px;
  width: 100%;
  background-color: #c4c4c4;
`

export const Text = styled.p`
  margin-top: 25px;
  ${textStyles.text};
  white-space: pre-wrap;
`

export const Buttons = styled.div`
  margin-top: 35px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const Back = styled.div`
  ${textStyles.text};
  padding: 10px 30px;
  cursor: pointer;
  margin-right: 25px;
  text-transform: uppercase;
`

export const ConfirmButton = styled(ActionButton)`
  width: 100%;
  max-width: 250px;
`
